<script>
  import {
    VListItem
  } from 'vuetify/lib'
  export default {
    name: 'wh-list-item',
    extends: VListItem
  };
</script>